import { render, staticRenderFns } from "./cabinet-requests-item-content-document.vue?vue&type=template&id=344676d8&scoped=true&"
import script from "./cabinet-requests-item-content-document.vue?vue&type=script&lang=js&"
export * from "./cabinet-requests-item-content-document.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-requests-item-content-document.vue?vue&type=style&index=0&id=344676d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344676d8",
  null
  
)

export default component.exports